import { invoke, type InvokeArgs } from "@tauri-apps/api/core"
import type { ClientSdk } from "./ClientSdk"

/** Thin wrapper around `@tauri-apps/api/core`'s `invoke` — behavior is unchanged from before the
 * `ClientSdk` abstraction existed, this just gives it the shared interface shape. */
export class TauriClientSdk implements ClientSdk {
  readonly kind = "tauri" as const

  invoke<T>(cmd: string, args?: Record<string, unknown>): Promise<T> {
    return invoke<T>(cmd, args as InvokeArgs)
  }
}
